import {
  setDefaultSettings,
  setLayoutSettings
} from 'app/redux/actions/LayoutActions'
import { useEffect, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { matchPath, useHistory, useLocation } from 'react-router-dom'
import { isMdScreen } from 'utils'
import routes from './../../RootRoutes'
import { Layout1SettingsChtc, LeftSidebarMode } from './Layout1SettingsChtc'

export const useSidebarMode = () => {
  const history = useHistory()
  const locationFromRouter = useLocation()

  const settings = useSelector<{
    layout: { settings: { layout1Settings: Layout1SettingsChtc } }
  }>((state) => state.layout.settings) as {
    layout1Settings: Layout1SettingsChtc
  }

  const [mode, setMode] = useState<LeftSidebarMode>()

  //@ts-expect-error
  const currentRoute = routes.find((route) =>
    matchPath(locationFromRouter.pathname, {
      path: route.path,
      exact: false,
      strict: false
    })
  )

  const allowClosing = Boolean(currentRoute?.showCollapseBtn || isMdScreen())
  const [isHidden, setIsHidden] = useState(true)

  const dispatch = useDispatch()

  useEffect(() => {
    const unlisten = history.listen((location: Location) => {
      const matchedRoute = routes.find((route) =>
        matchPath(location.pathname, {
          path: route.path,
          exact: false,
          strict: false
        })
      )

      if (matchedRoute?.collapseByDefault) {
        updateSidebarMode({ mode: 'close' })
      } else {
        handleResize(settings.layout1Settings.leftSidebar.mode)
        // updateSidebarMode({ mode: settings.layout1Settings.leftSidebar.mode })
      }
    })

    return () => {
      unlisten()
    }
  }, [history, settings.layout1Settings.leftSidebar.mode])

  const updateSidebarMode = (
    sidebarSettings: Partial<Layout1SettingsChtc['leftSidebar']>
  ): void => {
    const updatedSettings = {
      ...settings,
      layout1Settings: {
        ...settings.layout1Settings,
        leftSidebar: {
          ...settings.layout1Settings.leftSidebar,
          ...sidebarSettings
        },
      }
    }
    setMode(sidebarSettings.mode)
    dispatch(setLayoutSettings(updatedSettings))
    dispatch(setDefaultSettings(updatedSettings))
  }

  const handleResize = (mode?: LeftSidebarMode) => {
    const windowWidth = window.innerWidth
    console.log('Window width:', windowWidth)  
    if (windowWidth < 1280) {
      updateSidebarMode({ mode: 'close' })
    } else {
      updateSidebarMode({ mode: mode || 'full' })
    }
  }

  useEffect(() => {
    window.addEventListener('resize', () => handleResize())
    return () => {
      window.removeEventListener('resize', () => handleResize())
    };
  }, [])

  return {
    mode,
    allowClosing,
    isHidden,
    updateSidebarMode
  }
}
